import React from "react"
import { View, Image, TouchableOpacity, Linking } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import { Avatar } from "react-native-paper"
import { baseColors } from "@Constants/baseStyles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { AntDesign, Feather, Fontisto, Ionicons, MaterialCommunityIcons } from "@expo/vector-icons"
import moment from "moment"
import { dbDateFormat } from "@Utils/utils"

export const EmbeddedPost = (props) => {
    const {
        blogURL,
        blogTitle,
        blogContent,
        profilePhoto,
        profileName,
        commentCount,
        shareCount,
        reactionCount,
        createdAt,
        postContentUrl,
        postDescription
    } = props
    return (
        <TouchableOpacity
            style={{ marginBottom: RFValue(20) }}
            onPress={() => {
                if (Linking.canOpenURL(blogURL)) {
                    Linking.openURL(blogURL)
                }
            }}
        >
            <View style={{ borderRadius: 15, marginTop: 15, backgroundColor: "#f2f5f7" }}>
                {/** header */}
                <View style={{ display: "flex", flexDirection: "row", padding: 10, justifyContent: "space-between" }}>
                    <View style={{ flexDirection: "row" }}>
                        <Avatar.Image size={40} source={{ uri: profilePhoto }} />
                        <Spacer width={10} />
                        <View style={{ display: "flex", flexDirection: "column" }}>
                            <View style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                <OpenSansText fontSize={RFValue(14)} fontWeight={"bold"}>
                                    {profileName}
                                </OpenSansText>
                                <Spacer width={5} />
                                <MaterialCommunityIcons name="check-circle" color="#367cff" />
                            </View>
                            <View style={{ display: "flex", flexDirection: "row" }}>
                                <OpenSansText color={baseColors.grey}>
                                    {moment(createdAt, dbDateFormat + " HH:mm").format("DD MMMM, HH:mm")}{" "}
                                </OpenSansText>
                                <Ionicons name="earth" />
                            </View>
                        </View>
                    </View>
                    <View>
                        <Feather name="more-horizontal" size={20} style={{ marginRight: 10 }} />
                    </View>
                </View>
                {/** end header */}
                <View style={{ paddingVertical: 10, padding: 10 }}>
                    <OpenSansText>{postDescription}</OpenSansText>
                </View>
                <View>
                    <Image source={{ uri: postContentUrl }} style={{ width: "100%", height: 200 }} />
                </View>
                <View style={{ padding: 10, backgroundColor: "#e1e2e3" }}>
                    <View
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: 20,
                            width: 30,
                            height: 30,
                            paddingLeft: 11,
                            position: "absolute",
                            paddingTop: 6,
                            top: -15,
                            right: 10
                        }}
                    >
                        <Fontisto name="info" size={15} />
                    </View>
                    <OpenSansText color={baseColors.grey}>{blogURL?.toUpperCase()}</OpenSansText>
                    <OpenSansText fontWeight={"bold"}>{blogTitle}</OpenSansText>
                    <OpenSansText>{blogContent}</OpenSansText>
                </View>
                <View
                    style={{
                        alignItems: "center",
                        padding: 10,
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                        //backgroundColor: baseColors.white
                    }}
                >
                    <View style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <View
                            style={{
                                backgroundColor: "#367cff",
                                borderRadius: 20,
                                width: 25,
                                height: 25,
                                padding: 4
                            }}
                        >
                            <AntDesign name="like1" color={baseColors.white} size={15} />
                        </View>
                        <Ionicons style={{ marginLeft: -5 }} name="heart-circle" color={"#f40"} size={30} />
                        <OpenSansText>{`${reactionCount} `}</OpenSansText>
                    </View>
                    <View style={{ display: "flex", flexDirection: "row" }}>
                        <OpenSansText>{`${commentCount} commentaires`}</OpenSansText>
                        <Spacer width={20} />
                        <OpenSansText>{`${shareCount} partages`}</OpenSansText>
                    </View>
                </View>
            </View>
        </TouchableOpacity>
    )
}
